import { render, staticRenderFns } from "./OpenTill.vue?vue&type=template&id=3994f8cc&scoped=true&"
import script from "./OpenTill.vue?vue&type=script&lang=js&"
export * from "./OpenTill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3994f8cc",
  null
  
)

export default component.exports